﻿import { EmailModel } from '../../enums/index';
import { IEmailSendee } from './email-sendee';
import { IEmailTag } from './email-tag';

export interface IEmailTemplate {
    id: number;
    emailModel: EmailModel;
    senderContactId: number;
    subject: string;
    body: string;
    sendToEntity: boolean;
    emailSendees: IEmailSendee[];
    emailTags: IEmailTag[];
}
